function initOnScroll(search) {

	const contentStreamElement = document.getElementById('contentStream');

	const options = {
		root: null,
		rootMargin: '0px',
		threshold: 0
	};

	function handleIntersection(entries) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				search.start();
				observer.disconnect();
				document.dispatchEvent( new CustomEvent('algolia:search:init') );
			}
		});
	}
	
	const observer = new IntersectionObserver(handleIntersection, options);

	observer.observe(contentStreamElement);
}

export default initOnScroll;